import { render, staticRenderFns } from "./RecipeCard.vue?vue&type=template&id=6d304b68"
import script from "./RecipeCard.vue?vue&type=script&lang=js"
export * from "./RecipeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports